import { render } from "./PaymentInitErrors.vue?vue&type=template&id=af868f5a"
import script from "./PaymentInitErrors.vue?vue&type=script&lang=js"
export * from "./PaymentInitErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__